import React, {
    useCallback,
    useEffect,
    useMemo,
    useState,
    Suspense,
} from "react";
import { deleteItem, fetchData, toggleStatus } from "../../utils/apiUtils";
import { PlusButton } from "../../helper/ImageFormat";

import DeleteModel from "../../Components/DeleteModel";
import Breadcrumb from "../../helper/Breadcrumb";
import ThemeTable from "./themeTable";
import { useNavigate } from "react-router-dom";
const Theme = () => {

    const navigate = useNavigate()
    const [loading, setLoading] = useState(true);
    const [theme, settheme] = useState([]);
    const [search, setSearch] = useState("");
    const [deleteItemId, setDeleteItemId] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);
    const totalPages = useMemo(
        () => Math.ceil(totalCount / perPage),
        [totalCount, perPage]
    );

    const handleEditClick = (data) => {
    navigate("/add-theme",{state:data})
    };

    const fetchtheme = useCallback(
        async (page = 1, searchQuery = "") => {
            setLoading(true);
            await fetchData(
                "theme",
                { perPage, pageNo: page, search: searchQuery },
                settheme,
                setTotalCount,
                setCurrentPage,
                setLoading
            );
        },
        [perPage]
    );

    useEffect(() => {
        const delay = search ? 500 : 0;
        const handler = setTimeout(() => {
            fetchtheme(1, search);
        }, delay);

        return () => clearTimeout(handler);
    }, [search, perPage]);

    const handleDelete = async (data) => {
        setDeleteItemId(data);
        setDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        setIsDeleting(true);
        try {
            const res = await deleteItem("theme", deleteItemId?.id, fetchtheme,);
            setDeleteItemId({});
            setDeleteModalOpen(false);
            return res;
        } catch (err) {
            throw err;
        } finally {
            setIsDeleting(false);
        }
    };

    const handleStatusToggle = async (theme) => {
        const data = await toggleStatus(
            "theme-status",
            theme?.id,
            fetchtheme
        );
        if (Object.keys(data).length > 0) {
            settheme((prevtheme) =>
                prevtheme.map((curr) =>
                    curr.id === theme.id ? { ...curr, isActive: data?.isActive } : curr
                )
            );
        }
    };

    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
            fetchtheme(page);
        }
    };
    const handleAdd = () => {
        navigate("/add-theme")
    };

    const breadcrumbdata = [
        { label: "Home", path: "/" },
        { label: "Currency", path: "/theme" },
    ];


    return (
        <>
            <div className="content-wrapper">
                <div
                    className="page-header mt-5"
                    style={{ display: "flex", justifyContent: "space-between" }}
                >
                    <h3 className="custom-page-title">Theme</h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>

                <div
                    className="d-flex justify-content-between mb-2"
                    style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
                >
                    <select
                        className="form-control form-control-sm w-auto"
                        value={perPage}
                        onChange={(e) => setPerPage(Number(e.target.value))}
                    >
                        {[5, 10, 20, 50, 100, 150].map((limit) => (
                            <option key={limit} value={limit}>
                                {limit}
                            </option>
                        ))}
                    </select>

                    <div style={{ display: "flex", gap: "20px" }}>
                        <div className="search-box">
                            <button className="btn-search">
                                <i className="fas fa-search"></i>
                            </button>
                            <input
                                type="text"
                                className="input-search"
                                placeholder="Type to Search..."
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>

                        <PlusButton handleAdd={handleAdd} module={"theme"} />
                    </div>
                </div>

                <ThemeTable
                    loading={loading}
                    theme={theme}
                    currentPage={currentPage}
                    perPage={perPage}
                    totalPages={totalPages}
                    totalCount={totalCount}
                    handlePageClick={handlePageClick}
                    handleEditClick={handleEditClick}
                    handleDelete={handleDelete}
                    handleStatusToggle={handleStatusToggle}
                    selected={selected}
                    setSelected={setSelected}
                />
            </div>


            <Suspense fallback={<div>Loading...</div>}>
                <DeleteModel
                    deleteModalOpen={deleteModalOpen}
                    setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
                    onConfirm={confirmDelete}
                    itemName="theme"
                    isDeleting={isDeleting}
                />
            </Suspense>
        </>
    );
};

export default Theme;
